import { doc } from 'firebase/firestore';

import { fcmTokenConverter } from './converters/fcm-token';
import { CollectionOptions, getDatabase } from './helpers';

export const getFcmTokenDoc = (token: string) =>
  doc(getDatabase(), CollectionOptions.FcmTokens, token).withConverter(
    fcmTokenConverter,
  );
